module.exports = __webpack_public_path__ + "img/arrow-profile.38f6985b.svg";